var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow-button-navigation-wrapper",on:{"click":_vm.handleClick}},[_c('button',{staticClass:"arrow-button-navigation",style:(_vm.cssVars)},[_c('MIcon',{staticClass:"arrow-icon",attrs:{"icon":_vm.arrowBackSmoothIcon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }